import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../components/content/axiosConfig';
import { queryKeys } from './queryKeys';

export function useDashboardStaff(options = {}) {
  return useQuery({
    queryKey: queryKeys.dashboardStaff(),
    queryFn: async () => {
      const response = await axiosInstance.get('api/DashBoard/GetStaffReport');
      return response.data ?? {};
    },
    staleTime: 2 * 60_000,
    ...options,
  });
}
